import { registerModule } from '../../core/module.js';
import { Checkout } from './Checkout.js';
import { PriceCheck, Shift, Held } from './Sell.js';

/** The till: selling, price checks, the shift and held sales. */
export default registerModule({
  id: 'till',
  order: 10,
  nav: [
    { to: '/checkout', labelKey: 'nav.checkout', icon: '🧾', group: 'sell', permission: 'till.sell', bottom: 1, order: 1, primary: 1, hintKey: 'nav.hintCheckout' },
    { to: '/price-check', labelKey: 'nav.priceCheck', icon: '🔍', group: 'sell', permission: 'till.price_check', bottom: 3, order: 3, primary: 4, hintKey: 'nav.hintPriceCheck' },
    { to: '/shift', labelKey: 'nav.shift', icon: '💵', group: 'sell', permission: 'shift.open', bottom: 4, order: 4, primary: 5, hintKey: 'nav.hintShift', requiresSetting: 'shiftsEnabled' },
    { to: '/held', labelKey: 'nav.held', icon: '⏸', group: 'sell', permission: 'till.hold', order: 5, hintKey: 'nav.hintHeld', requiresSetting: 'holdSalesEnabled' },
  ],
  routes: [
    { path: '/checkout', element: <Checkout />, permission: 'till.sell', titleKey: 'checkout.title' },
    { path: '/price-check', element: <PriceCheck />, permission: 'till.price_check', titleKey: 'priceCheck.title' },
    { path: '/shift', element: <Shift />, permission: 'shift.open', titleKey: 'shift.title', requiresSetting: 'shiftsEnabled' },
    { path: '/held', element: <Held />, permission: 'till.hold', titleKey: 'nav.held', requiresSetting: 'holdSalesEnabled' },
  ],
});
